import React, { useState, useMemo } from "react";
import { Dialog, IconButton, Box, Tooltip } from "@material-ui/core";
import {
	CloseRounded,
	ChevronLeft,
	ChevronRight,
	FileCopyOutlined,
} from "@material-ui/icons";
import { useImagePreviewModalStyles } from "../utils/styles";

const ImagePreviewModal = ({
	open,
	file,
	imageFiles = [],
	onClose,
	resources,
}) => {
	const classes = useImagePreviewModalStyles();

	const initialIndex = imageFiles.findIndex((img) => img.id === file.id);
	const [currentIndex, setCurrentIndex] = useState(
		initialIndex >= 0 ? initialIndex : 0
	);
	const currentImage = useMemo(
		() => imageFiles[currentIndex],
		[imageFiles, currentIndex]
	);
	const hasPrevious = currentIndex > 0;
	const hasNext = currentIndex < imageFiles.length - 1;

	const [copied, setCopied] = useState(false);

	const handlePrev = () => {
		if (hasPrevious) setCurrentIndex((i) => i - 1);
	};
	const handleNext = () => {
		if (hasNext) setCurrentIndex((i) => i + 1);
	};
	const handleClose = () => {
		onClose && onClose();
	};
	const handleCopy = () => {
		if (currentImage?.originalContent) {
			navigator.clipboard.writeText(currentImage.originalContent);
			setCopied(true);
			setTimeout(() => setCopied(false), 1200);
		}
	};

	return (
		<Dialog
			open={open}
			onClose={handleClose}
			PaperProps={{
				style: {
					background: "#000",
				},
			}}
			fullScreen
		>
			<Box display="flex" justifyContent="space-between" padding="1.5rem">
				<Tooltip title="Close" placement="bottom">
					<IconButton
						onClick={handleClose}
						className={classes.closeButton}
						id="image-preview-close"
					>
						<CloseRounded />
					</IconButton>
				</Tooltip>

				<Tooltip
					title={
						copied
							? resources["CopiedFeedbackTooltip"]
							: resources["CopyURLTooltip"]
					}
					placement="bottom"
				>
					<IconButton
						onClick={handleCopy}
						className={classes.copyButton}
						id="image-preview-copy"
					>
						<FileCopyOutlined />
					</IconButton>
				</Tooltip>
			</Box>

			<div className={classes.imageContainer}>
				<IconButton
					color="primary"
					onClick={handlePrev}
					className={`${classes.navButton} ${classes.navLeft}`}
					disabled={!hasPrevious}
					id="image-preview-prev"
				>
					<ChevronLeft />
				</IconButton>

				<div className={classes.image}>
					<img
						src={currentImage?.originalContent}
						alt={currentImage?.description || "Image"}
						className={classes.imageContent}
					/>
				</div>

				<IconButton
					color="primary"
					onClick={handleNext}
					className={`${classes.navButton} ${classes.navRight}`}
					disabled={!hasNext}
					id="image-preview-next"
				>
					<ChevronRight />
				</IconButton>
			</div>
		</Dialog>
	);
};

export default ImagePreviewModal;
